import i18next from 'i18next';
import React from 'react';
import PublicWrapper from 'shared/components/layout/PublicWrapper';
import ContentEn from './locales/ContentEn';
import ContentDe from './locales/ContentDe';
import { Trans, useTranslation } from 'react-i18next';

const Terms = () => {
  const { t } = useTranslation();
  const lang = i18next.language ? i18next.language.split('-')?.[0] : 'en';
  const Content = lang === 'en' ? ContentEn : ContentDe;

  return (
    <PublicWrapper>
      <div className='border-bottom flex-fill mt-md-8'>
        <div className='container'>
          <div className='d-flex flex-wrap'>
            <div className='col-md-8 m-auto col-12 py-10 py-md-15 pb-20 pr-0 pr-md-16 pl-0'>
              <h1 className='mb-11'>{t('terms_title')}</h1>
              <p className='mb-20'>
                <Trans i18nKey='terms_sub_title' />
              </p>
              <Content />
            </div>
          </div>
        </div>
      </div>
    </PublicWrapper>
  );
};

export default Terms;
